export const SESSION_START_NEW_WORK_GIT_COMPLETED_EVENT = "cord:session-start-new-work-git-completed"

export interface SessionStartNewWorkGitCompletedDetail {
  sessionId: string
  ok: boolean
  newBranch?: string | null
  baseBranch?: string | null
  error?: string | null
}

export function dispatchSessionStartNewWorkGitCompleted(
  detail: SessionStartNewWorkGitCompletedDetail,
): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(
    new CustomEvent<SessionStartNewWorkGitCompletedDetail>(
      SESSION_START_NEW_WORK_GIT_COMPLETED_EVENT,
      {
        detail,
      },
    ),
  )
}
